import {
  FormError,
  SignUpFormData,
} from "../../../../assets/Types/AcfGroupTypes";

export default function validateClasses(
  formData: SignUpFormData,
  styles: any,
  emailError: FormError
) {
  const firstNameValidationClass = formData["first_name"].validation.hasError
    ? styles.inputError
    : undefined;

  const lastNameValidationClass = formData["last_name"].validation.hasError
    ? styles.inputError
    : undefined;

  const firstAndLastNameValidationClass =
    formData["first_name"].validation.hasError ||
    formData["last_name"].validation.hasError
      ? styles.fullNameError
      : styles.fullName;

  const emailValidationClass = emailError.validation.hasError
    ? styles.inputError
    : undefined;

  const emailNoBottomValidationClass = emailError.validation.hasError
    ? styles.inputErrorNoBotton
    : undefined;

  const securityCopyNoBottomValidationClass = emailError.validation.hasError
    ? styles.lockedContainerError
    : undefined;

  const emailLabelValidationClass = emailError.validation.hasError
    ? styles.formLabelError
    : styles.formLabel;

  const passwordValidationClass = formData.password.validation.hasError
    ? styles.inputErrorNoBotton
    : undefined;

  const phoneNumberValidationClass = formData["phone_number"].validation
    .hasError
    ? styles.inputErrorNoBotton
    : undefined;

  const phoneNumberLabelValidationClass = formData["phone_number"].validation
    .hasError
    ? styles.formLabelError
    : styles.formLabel;

  const agreementValidationClass =
    formData.agreement.validation.hasError && !formData.agreement.value
      ? styles.agreementCheckboxError
      : undefined;

  const inputErrorCheckBox =
    formData.agreement.validation.hasError && !formData.agreement.value
      ? styles.inputErrorCheckbox
      : undefined;

  const inputNormalCheckBox =
    !formData.agreement.validation.hasError && !formData.agreement.value
      ? styles.inputNormalCheckbox
      : undefined;

  const inputCheckedCheckBox = formData["agreement"].value
    ? styles.inputCheckedCheckbox
    : undefined;

  const checkboxClass = `${inputErrorCheckBox} ${inputNormalCheckBox} ${inputCheckedCheckBox}`;

  const licenseValidationClass = formData.license.validation.hasError
    ? styles.inputErrorNoBotton
    : undefined;

  const licenseLabelValidationClass = formData.license.validation.hasError
    ? styles.formLabelError
    : styles.formLabel;

  const notApplicableValidationClass =
    formData.notApplicable.validation.hasError && !formData.notApplicable.value
      ? styles.agreementCheckboxError
      : undefined;

  const notApplicableinputErrorCheckBox =
    formData.notApplicable.validation.hasError && !formData.notApplicable.value
      ? styles.inputErrorCheckbox
      : undefined;

  const notApplicableinputNormalCheckBox =
    !formData.notApplicable.validation.hasError && !formData.notApplicable.value
      ? styles.inputNormalCheckbox
      : undefined;

  const notApplicableinputCheckedCheckBox = formData["notApplicable"].value
    ? styles.inputCheckedCheckbox
    : undefined;

  const notApplicableCheckboxClass = `${notApplicableinputErrorCheckBox} ${notApplicableinputNormalCheckBox} ${notApplicableinputCheckedCheckBox}`;

  const smartDisplayValidationClass = formData.smartDisplay.validation.hasError
    ? styles.inputError
    : undefined;

  const globalProfessionsValidationClass = formData.globalProfessionIds
    .validation.hasError
    ? styles.inputError
    : undefined;

  return {
    firstNameValidationClass,
    lastNameValidationClass,
    firstAndLastNameValidationClass,
    emailValidationClass,
    emailNoBottomValidationClass,
    emailLabelValidationClass,
    passwordValidationClass,
    phoneNumberValidationClass,
    phoneNumberLabelValidationClass,
    agreementValidationClass,
    checkboxClass,
    licenseValidationClass,
    licenseLabelValidationClass,
    notApplicableValidationClass,
    notApplicableCheckboxClass,
    smartDisplayValidationClass,
    globalProfessionsValidationClass,
    securityCopyNoBottomValidationClass,
  };
}
